import styled from 'styled-components'
import { MaterialIcon } from '@dsny/dsny-component-library'
import { releaseInfoMobileDownQuery } from '../../responsiveQueries'

export const TrackContainer = styled.div`
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.neutralW30}`};
`

export const TrackRowBody = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 43px auto auto;
  column-gap: 24px;
  align-items: center;
  width: 100%;
  padding: 16px;
  border-radius: 5px;

  ${TrackContainer}:hover & {
    background-color: ${({ theme }) => theme.colors.neutralW20};
    cursor: pointer;
  }

  @media ${releaseInfoMobileDownQuery} {
    grid-template-columns: minmax(0, 1fr) auto auto;
    column-gap: 16px;
    padding: 8px;
  }
`

export const TrackContentCluster = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  min-width: 0;

  @media ${releaseInfoMobileDownQuery} {
    gap: 16px;
  }
`

export const TrackLeadingCell = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 10px;
  min-width: 10px;
  height: 24px;
`

export const PlayWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  display: flex;
  align-items: center;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-50%);

  ${TrackRowBody}:hover & {
    opacity: 1;

    svg {
      width: 18px;
      height: 18px;
    }
  }
`

export const TrackNumber = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.neutralW70};
  line-height: 1.5;

  ${TrackRowBody}:hover & {
    opacity: 0;
  }
`
export const TrackNumberList = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.neutralW70};
`

export const SecondRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding-top: 4px;
  min-width: 0;
`

export const ArtistName = styled.span`
  font-size: 14px;
  line-height: 1.2;
  max-width: 100%;
  min-width: 0;
  display: inline-block;
  color: ${({ theme }) => theme.colors.neutralW70};
`

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`

export const TrackTitle = styled.span`
  max-width: 100%;
  min-width: 0;
  display: inline-block;
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme, $isPlaying }) =>
    $isPlaying ? theme.colors.player50 : theme.colors.neutralW70};
`

export const TrackVersion = styled.span`
  font-size: 16px;
  font-weight: 700;
  display: inline-block;
  color: ${({ theme, $isPlaying }) =>
    $isPlaying ? theme.colors.player50 : theme.colors.neutralW70};
`

export const TrackDuration = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.neutralW70};
  justify-self: end;
  text-align: right;
  white-space: nowrap;
  line-height: 1.5;

  @media ${releaseInfoMobileDownQuery} {
    display: none;
  }
`

export const IconsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-shrink: 0;

  svg {
    width: 16px;
    height: 16px;
  }
`

export const PlayIcon = styled(MaterialIcon)`
  ${TrackContainer}:hover & {
    display: flex;
  }
`

export const ExpandIcon = styled.div`
  grid-column: 5/6;
`

export const TrackMetadataExpandButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 5px;
  background: transparent;
  color: ${({ theme }) => theme.colors.neutralW100};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.neutralW30};
  }
`

export const MetadataTrackItem = styled.div`
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.neutralW30}`};
`

export const MetadataTrackHeader = styled.button`
  width: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 24px;
  padding: 16px;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  text-align: left;
  border-radius: 5px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.neutralW20};
  }

  @media ${releaseInfoMobileDownQuery} {
    gap: 16px;
    padding: 8px;
  }
`

export const MetadataTrackContentCluster = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  min-width: 0;

  @media ${releaseInfoMobileDownQuery} {
    gap: 16px;
  }
`

export const MetadataTrackNumber = styled.span`
  width: 10px;
  min-width: 10px;
  font-size: 16px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.neutralW70};
`

export const MetadataTrackBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`

export const MetadataTrackTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`

export const MetadataTrackTitle = styled.span`
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
  color: ${({ theme }) => theme.colors.neutralW70};
`

export const MetadataTrackArtist = styled.span`
  font-size: 14px;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.neutralW70};
`

export const MetadataTrackVersion = styled.span`
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
  color: ${({ theme }) => theme.colors.neutralW70};
`

export const MetadataExpandButton = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.neutralW100};
`
